import { Link } from "react-router-dom";
import leafVector from "../../assets/images/svg/leaf-vector.svg";
import { LATEST_NEWS_DATA_LIST } from "../../utils/defaults";
import Icons from "../common/components/Icons";
import BlueTag from "../common/ui/BlueTag";
import Cta from "../common/ui/Cta";
import Heading from "../common/ui/Heading";
import Paragraph from "../common/ui/Paragraph";
const LatestNews = () => {
  return (
    <div className="pt-[85px] md:pt-[100px] relative xl:pt-[140px]">
      <div className="container relative z-10">
        <div className="flex items-center w-full gap-6 justify-center lg:justify-between">
          <div className="lg:max-w-[461px]">
            <div className="max-lg:text-center">
              <BlueTag center={{ "<": 1024 }}>Our Latest News</BlueTag>
            </div>
            <Heading className="mt-1.5 md:mt-4 max-sm:max-w-[335px] max-lg:text-center">
              Explore our latest blogs and news
            </Heading>
          </div>
          <Cta className="!font-semibold max-lg:hidden !leading-100">
            View All Post
          </Cta>
        </div>

        <div className="grid md:grid-cols-2 gap-2.5 mt-10">
          {LATEST_NEWS_DATA_LIST.map((post, index) => (
            <div
              key={index}
              className="border border-black/10 flex flex-col group/parent h-full rounded-2xl max-md:mx-auto max-w-[558px] 2xl:max-w-[700px] max-sm:min-h-[400px] p-4 md:p-2.5 lg:p-4 bg-white transition-all hover:border-transparent 
              duration-300 ease-linear relative box-border hover:border-custom-green hover:shadow-serviceCard"
            >
              <div className=" w-full overflow-clip mx-auto h-[162px] rounded-lg sm:h-[190px] lg:h-[242px]">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full group-hover/parent:scale-105 mx-auto h-[162px] sm:h-[190px] lg:h-[242px] object-top object-cover rounded-lg"
                />
              </div>
              <div className="mt-3 md:mt-3.5 flex flex-col justify-between grow">
                <div>
                  <p className="text-xs lg:text-base font-normal !leading-150 text-custom-green">
                    by {post.author} // {post.date}
                  </p>
                  <h3 className="font-semibold text-base lg:text-lg mt-1.5 lg:mt-2 !leading-150 text-custom-black">
                    {post.title}
                  </h3>
                  <Paragraph className="!text-custom-gray-v4 line-clamp-4 lg:line-clamp-2 mt-2.5 lg:mt-4">
                    {post.description}
                  </Paragraph>
                </div>
                <Link
                  to="#"
                  className="inline-flex group transition-all duration-300 ease-linear mt-3 lg:mt-5 items-center gap-2.5 lg:gap-4"
                >
                  <span className="font-medium text-custom-xxs lg:text-lg !leading-150 text-custom-blue-v2">
                    Read More
                  </span>
                  <Icons
                    className="group-hover:translate-x-1"
                    icon="right-blue-arrow"
                  />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>

      <img
        className="absolute z-0 top-1.5 md:-top-10 xl:top-6 left-0 w-20 md:w-24 lg:w-[120px]"
        src={leafVector}
        alt="leaf"
      />
    </div>
  );
};

export default LatestNews;
